// JsFromRoutes CacheKey bc35d2cddbd274ed659f5bb52522e51e
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  socialGraph: /* #__PURE__ */ definePathHelper('get', '/consumer/calendar/events/:event_id/subscriptions/social_graph'),
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/calendar/events/:event_id/subscriptions'),
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/events/:event_id/subscriptions'),
  destroy: /* #__PURE__ */ definePathHelper('delete', '/consumer/calendar/events/:event_id/subscriptions/:id'),
}
